<template>
  <div class="block container py-24 sm:py-48 xxl:px-24">
    <div class="w-full mx-auto md:w-3/5 lg:w-1/2">
      <div class="mb-12" v-html="component.title" />
      <div class="mb-48 last:mb-0">
        <div
          v-for="(question, index) in component.questions"
          :key="question.id"
          class="accordion border-b border-border overflow-hidden relative"
          :class="slideActive(index)"
        >
          <div
            class="p-16 pl-0 pr-48 sm:pr-56 sm:py-20 flex justify-between items-center cursor-pointer"
            @click="slideToggle(index)"
          >
            <span class="text-base font-medium text-blue-75 transform">
              {{ question.question }}
            </span>
            <fa class="text-blue-75" :icon="['far', 'chevron-down']" />
          </div>
          <transition name="fade">
            <div
              v-if="slideShow(index)"
              class="accordion__content text-sm px-0 p-16 sm:p-24 pt-0 sm:pt-0 sm:px-0"
              v-html="question.answer"
            />
          </transition>
        </div>
      </div>
      <a
        v-if="component.button"
        :href="component.button.url"
        :target="component.button.target"
        class="btn btn--transparent"
      >
        {{ component.button.title }}
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentBlock from '~/models/component-block';

import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    component: {
      type: ComponentBlock,
      required: true,
    },
  },
  data() {
    return {
      slidesShown: [] as number[],
      isActive: false,
    };
  },
  methods: {
    slideToggle(index: number) {
      for (let i = 0; i < this.slidesShown.length; i++) {
        if (this.slidesShown[i] === index) return this.slidesShown.splice(i, 1);
      }
      return this.slidesShown.push(index);
    },
    slideShow(index: number) {
      for (let i = 0; i < this.slidesShown.length; i++) {
        if (this.slidesShown[i] === index) return true;
      }
      return false;
    },
    slideActive(index: number) {
      for (let i = 0; i < this.slidesShown.length; i++) {
        if (this.slidesShown[i] === index) return 'active';
      }
      return '';
    },
  },
});
</script>

<style scoped>
.accordion {
  .fa-chevron-down {
    @apply absolute right-0 transform;
    transition: opacity 0.15s ease-in-out;

    @screen sm {
      @apply top-24;
    }
  }

  &.active {
    .fa-chevron-down {
      @apply rotate-180;
    }
  }
}

.wysiwyg-block + .questions-block {
  .questions__content--no-image {
    @apply pt-0;
  }
}

.fade-enter-active {
  transition: opacity 0.75s;
}
.fade-leave-active {
  transition: opacity 0.15s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
